import ProfileImg from "../assets/img/profileImg.svg";
import bagImg from "../assets/img/employeSVG.svg";
import Guarantors from "../assets/img/Guarantors.svg";
import Flatmates from "../assets/img/Flatmates.svg";
import VectorIcon from "../assets/img/VectorIcon1.svg";
import useTranslator from "../hooks/useTranslator";

const DummyTenantDetailsHeader = () => {
  const { _t } = useTranslator();

  const user = {
    fname: "Test",
    lname: "User",
    employment_status: "employed",
    about_me: "",
    sharers: [],
    gurantor_added_id: [],
  };

  const llShowOnly = false;

  const getInitials = () => {
    return `${user.fname?.[0] || ""}${user.lname?.[0] || ""}`.toUpperCase();
  };

  const getEmploymentStatus = () => {
    switch (user.employment_status) {
      case "employed":
        return _t("employed");
      case "self_employed":
        return _t("selfEmployed");
      case "student":
        return _t("student");
      case "unemployed":
        return _t("unemployed");
      default:
        return _t("notAvailable");
    }
  };

  return (
    <div className={`profileinfo ${!llShowOnly ? "profileTenant" : ""}`}>
      <div className="row">
        <div className="col">
          <div className="profileheading">
            <div className="row">
              {/* USER INITIAL */}
              <div className="col-1">
                <div className="userfixed_css d-flex align-items-center justify-content-center">
                  <p className="Profileheading_change">{getInitials()}</p>
                </div>
              </div>

              {/* ID */}
              {!llShowOnly && (
                <div className="col documentNumberWrapper">
                  <div className="d-flex gap-2">
                    <img src={ProfileImg} className="vactorImg" />
                    <div>
                      <p className="Profileheading_change mb-2">
                        {_t(
                          "dniNieDetails",
                          "On new Skor Lite tenantDetails page header"
                        )}
                      </p>
                      <p className="Profileheading_change2">ABC123456</p>
                    </div>
                  </div>
                </div>
              )}

              {/* EMPLOYMENT */}
              <div className="col documentNumberWrapper">
                <div className="d-flex gap-2">
                  <img src={bagImg} className="vactorImg" />
                  <div>
                    <p className="Profileheading_change mb-2">
                      {_t("employmentStatus")}
                    </p>
                    <p className="Profileheading_change2">
                      {getEmploymentStatus()}
                    </p>
                  </div>
                </div>
              </div>

              {/* GUARANTORS */}
              <div className="col documentNumberWrapper">
                <div className="d-flex gap-2">
                  <img src={Guarantors} className="vactorImg" />
                  <div>
                    <p className="Profileheading_change mb-2">
                      {_t("guarantors")}
                    </p>
                    <div className="d-flex align-items-center gap-2">
                      <p className="Profileheading_change2">
                        {user.gurantor_added_id.length}
                      </p>
                      <img
                        src={VectorIcon}
                        className="Imagerutate ImageSizeSet"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* FLATMATES */}
              <div className="col documentNumberWrapper">
                <div className="d-flex gap-2">
                  <img src={Flatmates} className="vactorImg" />
                  <div>
                    <p className="Profileheading_change mb-2">
                      {_t("flatmates")}
                    </p>
                    <div className="d-flex align-items-center gap-2">
                      <p className="Profileheading_change2">
                        {user.sharers.length}
                      </p>
                      <img
                        src={VectorIcon}
                        className="Imagerutate ImageSizeSet"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ABOUT ME */}
        <div className="col-md-2">
          <div className="incomeDiv aboutMeCard">
            <div className="d-flex gap-2">
              <div className="w-100 wrapperButtonHeading">
                <div className="d-flex align-items-center custom-gap-2">
                  <img
                    src="/images/message-dots-solid.svg"
                    alt="Vector Icon"
                    className="vactorImg"
                  />
                  <p className="Profileheading_change">{_t("aboutMe")}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between gap-4 custom-mt-1">
                  <div className="d-flex align-items-center w-100">
                    <p className="Profileheading_change3 aboutMeDescription">
                      {_t("noInformation")}
                    </p>
                  </div>
                  <div className="infodorpdown summarydropdum position-relative">
                    <div
                      // onClick={() => setShowFreeTextPopup(true)}
                      className="cursor-pointer editButton"
                    >
                      <img src="/images/addGreen.svg" />
                      <p>{_t("add")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DummyTenantDetailsHeader;
